// extracted by mini-css-extract-plugin
export var form = "_dz-0";